import { Link } from 'react-router-dom';

export function LegalFooter({ fixed = true }: { fixed?: boolean } = {}) {
  return (
    <footer className={`${fixed ? 'fixed bottom-0 left-0 right-0 z-20' : 'relative'} border-t border-border bg-background py-3`}>
      <div className="mx-auto max-w-6xl px-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Plan My Garden</span>
        <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
        <Link to="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link>
        <Link to="/refund-policy" className="hover:text-foreground transition-colors">Refund Policy</Link>
      </div>
    </footer>
  );
}
